export default class Produto {
	constructor(
		nome='',
		descricao='',
		descricao_site='',
		categ_produto_id='',
		ativo_site=false,
		valor=''
	){
		this.nome = nome;
		this.descricao = descricao;
		this.descricao_site = descricao_site;
		this.categ_produto_id = categ_produto_id;
		this.ativo_site = ativo_site;
		this.valor = valor;
	}
}